import React from 'react';
import style from './style.module.scss';

const PrintPageBreak = () => {
  return <div className={style['print-page-break']} />;
};

export default PrintPageBreak;
